var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "small-12" },
    [
      !_vm.pendingGuidelines.length && _vm.curReviewerWithAccess
        ? _c("div", { staticClass: "no-guidelines" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("tenantProjects.submission.comment.addTechCommentHint")
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.pendingGuidelines.length
        ? _c("PostFitOutGuideline", {
            class: { "has-access": _vm.curReviewerWithAccess },
            attrs: {
              guidelines: _vm.pendingGuidelines,
              enableExpandByClickingTitle: _vm.isEditing,
              expand: true,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "secTitle",
                  fn: function (secTitleProps) {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isEditingId === secTitleProps.section.id,
                              expression:
                                "isEditingId === secTitleProps.section.id",
                            },
                          ],
                          staticClass: "section-title-editing",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: secTitleProps.section.displayOrder,
                                expression:
                                  "secTitleProps.section.displayOrder",
                              },
                            ],
                            staticClass: "section-title-order",
                            attrs: {
                              placeholder: _vm.$t(
                                "tenantProjects.submission.comment.section.number"
                              ),
                              type: "text",
                            },
                            domProps: {
                              value: secTitleProps.section.displayOrder,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  secTitleProps.section,
                                  "displayOrder",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: secTitleProps.section.value,
                                expression: "secTitleProps.section.value",
                              },
                            ],
                            staticClass: "section-title-text",
                            attrs: {
                              placeholder: _vm.$t(
                                "tenantProjects.submission.comment.section.title"
                              ),
                              type: "text",
                            },
                            domProps: { value: secTitleProps.section.value },
                            on: {
                              focusout: function ($event) {
                                return _vm.saveUpdate(
                                  null,
                                  secTitleProps.section.itemId
                                )
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  secTitleProps.section,
                                  "value",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isEditingId !== secTitleProps.section.id
                        ? _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.parseOrderNumber(
                                    secTitleProps.section.displayOrder
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(secTitleProps.section.value)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      secTitleProps.section.actionTexts &&
                      secTitleProps.section.actionTexts.length
                        ? _vm._l(
                            secTitleProps.section.actionTexts,
                            function (rec, k) {
                              return _c(
                                "div",
                                {
                                  key: secTitleProps.section.id + "_" + k,
                                  staticClass: "tip small-12",
                                },
                                [
                                  _c("span", { staticClass: "tip__text" }, [
                                    _vm._v(_vm._s(rec)),
                                  ]),
                                ]
                              )
                            }
                          )
                        : _vm._e(),
                    ]
                  },
                },
                _vm.curReviewerWithAccess
                  ? {
                      key: "secTitleAction",
                      fn: function (slotProps) {
                        return [
                          _c(
                            "DottedMenu",
                            [
                              _c("HKLButton", {
                                attrs: { action: "edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editSection(slotProps.section.id)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("HKLButton", {
                                attrs: { action: "add" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addSection(
                                      slotProps.section,
                                      slotProps.index
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("HKLButton", {
                                attrs: { action: "delete" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDelModalForSection(
                                      slotProps.index
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    }
                  : null,
                {
                  key: "item",
                  fn: function (sectionItemProps) {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.isEditingId ===
                                sectionItemProps.sectionItem.id,
                              expression:
                                "isEditingId === sectionItemProps.sectionItem.id",
                            },
                          ],
                          staticClass: "small-12",
                        },
                        [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: sectionItemProps.sectionItem.value,
                                expression:
                                  "sectionItemProps.sectionItem.value",
                              },
                              { name: "autosize", rawName: "v-autosize" },
                            ],
                            ref: _vm.getLineRefName(
                              sectionItemProps.sectionItem.id
                            ),
                            staticClass: "section-item__textarea",
                            attrs: {
                              placeholder: _vm.$t(
                                "tenantProjects.submission.comment.section.content"
                              ),
                              type: "text",
                            },
                            domProps: {
                              value: sectionItemProps.sectionItem.value,
                            },
                            on: {
                              focusout: function ($event) {
                                return _vm.saveUpdate(
                                  sectionItemProps.section.itemId,
                                  sectionItemProps.sectionItem.itemId
                                )
                              },
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  sectionItemProps.sectionItem,
                                  "value",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isEditingId !== sectionItemProps.sectionItem.id
                        ? [
                            _c(
                              "div",
                              { staticClass: "hkl-guideline__child-number" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      sectionItemProps.sectionItem
                                        .secondaryOrder === 0
                                        ? _vm.parseOrderNumber(
                                            sectionItemProps.sectionItem.order +
                                              1
                                          )
                                        : ""
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "pre",
                              { staticClass: "hkl-guideline__child-value" },
                              [
                                _vm._v(
                                  _vm._s(sectionItemProps.sectionItem.value)
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
                _vm.curReviewerWithAccess
                  ? {
                      key: "itemAction",
                      fn: function (slotProps) {
                        return [
                          _c(
                            "DottedMenu",
                            [
                              _c("HKLButton", {
                                attrs: { action: "edit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editLine(
                                      slotProps.sectionItem.id
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("HKLButton", {
                                attrs: { action: "add" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addLine(
                                      slotProps.sectionItem,
                                      slotProps.index
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("HKLButton", {
                                attrs: { action: "delete" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDelModalForLine(slotProps)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "deleteConfirmRef",
        attrs: { title: _vm.$t("deleteConfirmMsg"), okBtnAction: "delete" },
        on: { onOkClick: _vm.deleteSection },
      }),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "deleteLineConfirmRef",
        attrs: { title: _vm.$t("deleteConfirmMsg"), okBtnAction: "delete" },
        on: { onOkClick: _vm.deleteLine },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }